angular.module('dnecom')
    .filter('highlight', ["$sce", function ($sce) {
        return function (text, phrase, highlightClass) {
            if (!_.isNil(phrase) && phrase.length > 0) {
                highlightClass = (!_.isUndefined(highlightClass) && highlightClass.length > 0) ? highlightClass : 'text-complete';
                text = (text || '').replace(new RegExp('(' + phrase + ')', 'gi'), '<span class="' + highlightClass + '">$1</span>');
            }

            return $sce.trustAsHtml(text);
        }
    }]);